import fuelCardActions from "actions/fuelCards";
import modalActions from "actions/modal";
import { connect, tableStateToProps } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        ...tableStateToProps(state, "fuelCards"),
        allFuelCards: state.fuelCards.allItems,
        unlinkedFuelCards: state.fuelCards.unlinkedItems,
        driverFuelCards: state.fuelCards.driverItems,
        carFuelCards: state.fuelCards.carItems,
        allItemsCount: state.fuelCards.allItemsCount,
        unlinkedItemsCount: state.fuelCards.unlinkedItemsCount,
        driverItemsCount: state.fuelCards.driverItemsCount,
        carItemsCount: state.fuelCards.carItemsCount,
    });
    const mapDispatch = (dispatch) => {
        return {
            getAllFuelCards: (params) => dispatch(fuelCardActions.getAllFuelCards(params)),
            getUnlinkedFuelCards: (params) => dispatch(fuelCardActions.getUnlinkedFuelCards(params)),
            getDriverFuelCards: (params) => dispatch(fuelCardActions.getDriverFuelCards(params)),
            getCarFuelCards: (params) => dispatch(fuelCardActions.getCarFuelCards(params)),
            mergeParams: (params) => dispatch(fuelCardActions.mergeFuelCardsParams(params)),
            modal: (params) => dispatch(modalActions.open(params)),
            clearParams: (params = {}) =>
                dispatch(
                    fuelCardActions.mergeFuelCardsParams({
                        filters: [],
                        start: 0,
                        customFilters: {},
                        preparedFilter: {},
                        ...params,
                    }),
                ),
        };
    };
    return connect(mapState, mapDispatch)(Component);
}
